/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { LayerPickerIconProps } from '../iconUtilities';

export const LightningIcon = memo(({ 
    backgroundFillColor = '#82BC00',
    symbolFillColor = '#FFFFFF',
    width = 43,
    height = 43
}: LayerPickerIconProps) =>
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='12' cy='12' r='12' fill={backgroundFillColor} />
        <path fillRule='evenodd' clipRule='evenodd' d='M15.9027 11.3721H12.4536L14.3531 3L7.6 12.518H11.5141L9.55237 21.1622L15.9027 11.3721' fill={symbolFillColor}/>
    </svg>
);